<template lang="pug">
  .datatable
    table
      TableHeader(
        :title="title"
        :columns='Columns'
        @toggleOrder="toggleOrder")
      TableBody(:columns='Columns' :rows='Rows')
      TableFooter(:columns='Columns' :rows='Rows')
    TablePagination(:page="page" :totalPages="totalPages" @setPage="setPage")
</template>

<script>
import formatValue from './lib/format-value'
import TableHeader from './table-header'
import TablePagination from './table-pagination'
import TableBody from './table-body'
import TableFooter from './table-footer'
import stableSort from 'stable'

export default {
  name: 'datatable',
  components: { TableHeader, TableBody, TableFooter, TablePagination },
  props: [ 'columns', 'rows', 'title', 'order', 'orderBy', 'page', 'totalPages' ],
  data: function () {
    return {
      OrderBy: this.orderBy,
      Order: this.order
    }
  },
  computed: {
    Columns () {
      var order = this.Order
      var orderBy = this.OrderBy
      return this.columns.map(function (c) {
        return Object.assign({}, c, { order: ((c.id === orderBy) ? order : null) })
      })
    },
    Rows () {
      let rows = this.rows.slice()

      if (typeof (this.OrderBy) !== 'undefined') {
        const orderBy = this.OrderBy
        const order = (this.Order === 'ASC') ? 1 : -1
        stableSort.inplace(rows, function (a, b) {
          const va = a[orderBy]
          const vb = b[orderBy]
          if (va < vb) { return order * -1 }
          if (va > vb) { return order * 1 }
          return 0
        })
      }

      let columns = this.Columns

      return rows.map(function (row) {
        for (let column of columns) {
          let id = column.id
          let type = column.type
          row[id] = formatValue(row[id], type)
        }
        return row
      })
    }
  },
  methods: {
    setPage (page) {
      this.$emit('setPage', page)
    },
    toggleOrder (id) {
      if (this.OrderBy !== id) {
        this.Order = 'DESC'
      } else {
        this.Order = (this.Order === 'ASC') ? 'DESC' : 'ASC'
      }
      this.OrderBy = id
      this.$emit('setOrder', { order: id, direction: this.Order })
    }
  }
}
</script>

<style lang="stylus">

gray = #cccccc
lightgray = #e0e0e0
black = #333333
white = #ffffff

colors = {
  header: {
    hover: #f0f0f0
  }
  row: {
    even: white,
    odd: #f5f5f5,
    hover: #e8e8e8
  }
}

.datatable {
  font-family: "Open Sans", Helvetica, Arial

  &.is-loading {
    position: relative

    .datatable-controls {
      display: none
    }

    &:before {
      content: ''
      border-radius: 3px
      position: absolute
      background: rgba(white, .75)
      z-index: 1
      top: 0
      left: 0
      right: 0
      bottom: 0
    }
  }

  .v-spinner {
    position: absolute
    top: 3em
    left: 50%
    margin-left: -2em
  }

  h1 {
    font-size: 2em
    font-weight: bold
  }

  table {
    width: 100%
    border-collapse: collapse;
    border-radius: 3px

    * {
      transition: .5s
    }

    thead {
      th {
        text-transform: uppercase
        font-weight: bold
        background: white
        padding: 7px 10px
        text-align: left
        &.column-sortable {
          border-color: gray
          border-style: solid
          border-width: 1px 1px 2px
          &:hover {
            background: colors.header.hover
          }
        }
      }
    }

    tbody {
      td {
        text-align: right
        border: 1px solid lightgray
        padding: 3px 10px
        white-space: nowrap
        font-size: 90%
      }
      tr {
        &:nth-child(2n+1) {
          background: colors.row.odd
        }
        &:nth-child(2n+0) {
          background: colors.row.even
        }
        &:hover {
          background: colors.row.hover
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?675a7ab2